<template>
    <div class="loader">
        <Spinner/>
    </div>
</template>

<script>
    import Spinner from '@/assets/loader-black.svg'
	export default {
		name: "Loader",
        components: {
			Spinner
        }
	}
</script>

<style lang="scss" scoped>
    .loader{
        display: block;
        width: 50px;
        margin: 0px auto;
    }
</style>
